export default __webpack_public_path__ + "static/media/marzitelliBack.3846723d.png";